import React, { useContext, useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../../jss_setup";
import {
  CurrencyContext,
  currencies,
  TranslationContext,
  humanizeDurationFromMins,
} from "../../../umbilical_tools";
import { getExchangedPrice } from "../../../umbilical_hocs";
import { Button } from "../../../components/common/Button";
import ReactGA4 from "react-ga4";
import { useHistory } from "react-router-dom";
import { onViewFerryDetails } from ".";

export const labelAndMsg = [
  ["Latest Check-in", "checkIin"],
  ["Cabins/ Seating/ Extras", "Select your cabin, seating and extras"],
  // ["View Timetables", "Timetables"],
];
const btmBtnsGrey = "#e5e5e5";

const btnStyles = {
  display: "grid",
  placeItems: "center",
  textAlign: "center",
  borderRadius: jssVariables.half_gap,
  cursor: "pointer",
  fontSize: "small",
  padding: [0, jssVariables.half_gap],
  border: "1px solid",
  color: jssVariables.colors.base_color,
  background: "white",
  borderColor: jssVariables.colors.base_color,
  "&:hover": {
    background: btmBtnsGrey,
    borderColor: btmBtnsGrey,
  },
};
const styles = createUseStyles({
  BtmInfo: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    justifyContent: "center",
    padding: jssVariables.double_gap,
    ..._.get(props, "customStyles.BtmInfo", {}),
  }),
  btnsContr: (props) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${labelAndMsg.length}, 1fr)`,
    gridGap: jssVariables.half_gap,
    ..._.get(props, "customStyles.btnsContr", {}),
  }),
  btnDefault: (props) => ({
    ...btnStyles,
    borderColor: jssVariables.colors.base_color,
    background: jssVariables.colors.light,
    ..._.get(props, "customStyles.btnDefault", {}),
  }),
  btnActive: (props) => ({
    ...btnStyles,
    borderColor: btmBtnsGrey,
    background: btmBtnsGrey,
    ..._.get(props, "customStyles.btnActive", {}),
  }),
  msg: (props) => ({
    textAlign: "center",
    borderRadius: `calc(${jssVariables.border_radius} / 2)`,
    color: jssVariables.colors.base_color,
    background: btmBtnsGrey,
    width: "100%",
    padding: [jssVariables.half_gap, 0],
    ..._.get(props, "customStyles.msg", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    BtmInfo: (props) => ({
      paddingTop: 0,
      gridGap: jssVariables.half_gap,
      ..._.get(props, "customStyles.BtmInfo.smallscreen", {}),
    }),
    btnsContr: (props) => ({
      gridTemplateColumns: `repeat(${labelAndMsg.length}, 13rem)`,
      ..._.get(props, "customStyles.btnsContr.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const BtmInfo = ({ checkin_before_minutes }) => {
  const [selection, setSelection] = useState(0);
  const { t } = useContext(TranslationContext);

  const classes = styles({});

  function onSelect(input) {
    setSelection(input === selection ? -1 : input);
  }

  return (
    <div className={classes.BtmInfo}>
      <div className={classes.btnsContr}>
        {new Array(labelAndMsg.length).fill(0).map((x, idx) => (
          <div
            key={idx}
            className={
              idx === selection ? classes.btnActive : classes.btnDefault
            }
            onClick={() => onSelect(idx)}>
            {labelAndMsg[idx][0]}
          </div>
        ))}
      </div>
      {selection >= 0 && (
        <div className={classes.msg}>
          {selection > 0
            ? labelAndMsg[selection][1]
            : `${humanizeDurationFromMins(checkin_before_minutes)} ${t(
                "beforeDeparture"
              )}`}
        </div>
      )}
    </div>
  );
};
BtmInfo.defaultProps = {
  checkin_before_minutes: 0,
};
BtmInfo.propTypes = {
  checkin_before_minutes: PropTypes.number,
};

const priceAndActionsStyles = createUseStyles({
  PriceAndActions: (props) => ({
    display: "grid",
    placeContent: "center",
    placeItems: "center",
    paddingBottom: jssVariables.double_gap,
    gridGap: `calc(${jssVariables.normal_gap} * 1.5)`,
    ..._.get(props, "customStyles.PriceAndActions", {}),
  }),
  totalPrice: (props) => ({
    color: "#4F8E96",
    fontSize: "x-large",
    fontWeight: "bold",
    textAlign: "end",
    lineHeight: "normal",
    ..._.get(props, "customStyles.totalPrice", {}),
  }),
  priceTextLabel: (props) => ({
    color: jssVariables.colors.text.dark,
    fontSize: "medium",
    fontWeight: "normal",
    ..._.get(props, "customStyles.priceTextLabel", {}),
  }),

  [`@media ${jssVariables.media.smallscreen}`]: {
    PriceAndActions: (props) => ({
      gridTemplateColumns: "1fr max-content",
      paddingBottom: 0,
      justifyItems: "end",
      ..._.get(props, "customStyles.PriceAndActions.smallscreen", {}),
    }),
  },
});
export const PriceAndActions = ({
  ferry,
  page_session_id,
  customStyles,
  idx,
}) => {
  const classes = priceAndActionsStyles({ customStyles });
  const { currency: settedCurrency } = useContext(CurrencyContext);
  const { t } = useContext(TranslationContext);
  const history = useHistory();

  function onContinue() {
    onViewFerryDetails({
      history,
      token: ferry.token,
      provider: ferry.provider,
      page_session_id,
    });
    ReactGA4.event({
      category: "action",
      action: "See_ferry_details",
      label: "See_ferry_details",
    });
  }

  return (
    <div className={classes.PriceAndActions}>
      <div className={classes.totalPrice}>
        <span className={classes.priceTextLabel}>{`${t("from")} `}</span>
        {currencies[settedCurrency]}
        {getExchangedPrice({
          price: ferry.price.value,
          priceCurrency: ferry.price.currency,
          settedCurrency,
          withDecimals: true,
        })}
      </div>
      <Button
        id={`ferry_continue_${idx}`}
        text={t("continue")}
        size="large"
        onClick={() => onContinue()}
        customStyles={{
          ButtonDefault: {
            padding: `calc(${jssVariables.normal_gap} / 3) ${jssVariables.double_gap}`,
          },
        }}
      />
    </div>
  );
};
PriceAndActions.defaultProps = {
  ferry: {},
  page_session_id: "",
  customStyles: {},
};
PriceAndActions.propTypes = {
  ferry: PropTypes.object.isRequired,
  page_session_id: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
};
